import { render, staticRenderFns } from "./beneficiary-pending.vue?vue&type=template&id=2b02a770&scoped=true&"
import script from "./beneficiary-pending.vue?vue&type=script&lang=js&"
export * from "./beneficiary-pending.vue?vue&type=script&lang=js&"
import style0 from "./beneficiary-pending.vue?vue&type=style&index=0&id=2b02a770&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b02a770",
  null
  
)

export default component.exports